
import { Component, Vue } from 'vue-property-decorator';

// Components
import VButton from '@/components/VButton/VButton.vue';

type titlesType = {
    document: string[];
    report: string[];
};

@Component({
    components: { VButton },
})
export default class PMReports extends Vue {
    typeTitles: (keyof titlesType)[] = ['document', 'report'];

    buttonTitles = {
        document: ['bpc', 'dpcExec', 'dpcQuart', 'weeklyReport'],
        report: ['dpcExec', 'construction'],
    };

    goToPage(typeTitle: string, btnTitle: string) {
        this.$router.push({
            name: `projectManagement.${typeTitle}.${btnTitle}`,
        });
    }
}
